import { render } from "./UserImgUpload.vue?vue&type=template&id=1d7df367&scoped=true"
import script from "./UserImgUpload.vue?vue&type=script&lang=js"
export * from "./UserImgUpload.vue?vue&type=script&lang=js"

import "./UserImgUpload.vue?vue&type=style&index=0&id=1d7df367&scoped=true&lang=css"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d7df367"]])

export default __exports__